import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
    return (
        <div>
            <footer>
                <section className="footer__area-common background overflow-hidden position-relative z-1">
                    <div className="container">
                        <div className="row mb-minus-40 footer-wrap">
                            <div className="col-lg-4">
                                <div className="footer__widget footer__widget-item-1">
                                    <div className="footer__logo mb-20">
                                        <Link to="/">
                                            <img src="assets/imgs/footer/logo.png" alt="Nexus ID Systems" />
                                        </Link>
                                    </div>
                                    <div className="footer__content">
                                        <p>Nexus ID Systems is the premier partner for secure identity and card issuance solutions in India, authorized supplier of Entrust printers.</p>
                                    </div>
                                    <div className="footer__social mt-20 header__social">
                                        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="header__social-icon"><i className="fa-brands fa-facebook-f"></i></a>
                                        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="header__social-icon"><i className="fa-brands fa-instagram"></i></a>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-2 col-md-3 col-sm-6">
                                <div className="footer__widget footer__widget-item-2">
                                    <div className="footer__widget-title">
                                        <h4>Quick Links</h4>
                                    </div>
                                    <div className="footer__link">
                                        <ul>
                                            <li><Link to="/"><i className="fa-solid fa-angle-right"></i>Home</Link></li>
                                            <li><Link to="/printers"><i className="fa-solid fa-angle-right"></i>Printers</Link></li>
                                            <li><Link to="/solutions"><i className="fa-solid fa-angle-right"></i>Solutions</Link></li>
                                            <li><Link to="/contact"><i className="fa-solid fa-angle-right"></i>Contact</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-3 col-sm-6">
                                <div className="footer__widget footer__widget-item-3">
                                    <div className="footer__widget-title">
                                        <h4>Products</h4>
                                    </div>
                                    <div className="footer__link">
                                        <ul>
                                            <li><Link to="/printers"><i className="fa-solid fa-angle-right"></i>ID Card Printers</Link></li>
                                            <li><Link to="/smart-cards"><i className="fa-solid fa-angle-right"></i>Smart Cards</Link></li>
                                            <li><Link to="/accessories"><i className="fa-solid fa-angle-right"></i>Accessories</Link></li>
                                            <li><Link to="/solutions"><i className="fa-solid fa-angle-right"></i>ID Software</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6">
                                <div className="footer__widget footer__widget-item-4">
                                    <div className="footer__widget-title">
                                        <h4>Contact</h4>
                                    </div>

                                    <div className="footer__subscribe subscribe-2 d-flex mt-15">
                                        <ul>
                                            <li>
                                                <a href="https://maps.google.com/?q=Nexus+ID+Systems,Ernakulam,Kerala" target="_blank" rel="noopener noreferrer">
                                                    <span>
                                                        <i className="fa-solid fa-location-dot" style={{color: '#646464'}}></i>
                                                    </span>
                                                    Ernakulam, Kerala, India
                                                </a>
                                            </li>
                                            <li className="gap-10">
                                                <a href="tel:+917736744500">
                                                    <span>
                                                       <i className="fa-solid fa-phone" style={{color: '#646464'}}></i>
                                                    </span>
                                                    +91 7736744500
                                                </a>
                                            </li>
                                            <li>
                                                <a href="mailto:sales@nexusidsystems.com">
                                                    <span>
                                                        <i className="fa-solid fa-envelope" style={{color: '#646464'}}></i>
                                                    </span>
                                                    sales@nexusidsystems.com
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer__bottom-wrapper footer__bottom-home-1-bg">
                        <div className="container">
                            <div className="footer__bottom">
                                <div className="footer__copyright">
                                    <p>Copyright © 2024 Nexus ID Systems. All Rights Reserved.</p>
                                </div>

                                <div className="footer__copyright-menu">
                                    <ul>
                                        <li><Link to="/contact">Privacy Policy</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </footer>
        </div>
    )
}

export default Footer